// extracted by css-extract-rspack-plugin
module.exports =  {"spacing":"UserInfo__spacing___DoCrn","checkboxContainer":"UserInfo__checkboxContainer___FlsPC"};